import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { apiRequest, API_CONSTANTS } from "../libs/apiRequest";
import { useParams } from "react-router-dom";
import '../css/gtc-modal.css';

function GTCCreateGeoChannel(props: any) {

    const [chanName, setChanName] = useState('')
    const requestRef = useRef(false)
    const { service } = useParams();

    const createChannel = async () => {
        if (requestRef.current) {
            return;
        }
        requestRef.current = true;
        try {
            const res = await apiRequest({
                method: "POST",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "createchan",
                content: "json",
                data: {
                    channelName: chanName,
                    service: service
                }
            })
            if (res && res.status == 200) {
                alert("Success");
                window.location.reload();
            } else {
                alert(res.message);
            }
        } catch (error) {
            console.log("createChannel", error);
        }
        requestRef.current = false;
    }

    return (
        <Modal show={props.show} centered>
            <div className="modal-body">
                <div className="modal-header">
                    <h2 className="modal-title">Create New Channel</h2>
                    <p className="modal-description">
                        Set up a new API channel for your geolocation service
                    </p>
                    <button 
                        className="modal-close"
                        onClick={() => {
                            setChanName('');
                            props.close();
                        }}
                    >
                        <FontAwesomeIcon icon={faXmarkCircle} />
                    </button>
                </div>

                <div className="modal-form">
                    <div className="form-group">
                        <label className="form-label">Channel Name</label>
                        <input 
                            type="text"
                            value={chanName}
                            onChange={(e) => setChanName(e.target.value)} 
                            className="form-input"
                            placeholder="Enter channel name..."
                        />
                        <p className="form-note">
                            Note: You can only have one free channel. If multiple free channels are detected, 
                            we will automatically delete the extras.
                        </p>
                    </div>

                    <button 
                        className="create-button"
                        onClick={createChannel}
                    >
                        Create Channel
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default GTCCreateGeoChannel;